import { render, staticRenderFns } from "./itemOnlyText.vue?vue&type=template&id=90823fae&scoped=true&"
import script from "./itemOnlyText.vue?vue&type=script&lang=js&"
export * from "./itemOnlyText.vue?vue&type=script&lang=js&"
import style0 from "./itemOnlyText.vue?vue&type=style&index=0&id=90823fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90823fae",
  null
  
)

export default component.exports